import { StaticPageConfig } from "@7egend/dxp-web-core/lib/modules/cms/StaticPages/types"
import { CUSTOM_BLOCKS } from "../blocks"

const { image, title } = CUSTOM_BLOCKS.types

export default {
	sections: {
		"6": {
			containers: {
				"contacts/header": {
					blocks: [
						{
							types: [`${image.type}_${image.style}`],
						},
						{
							types: [`${title.type}_${title.style}`],
						},
					],
				},
			},
		},
	},
} as StaticPageConfig
